import React from "react";

const Missing = () => {
  return <div>404</div>;
};

export default Missing;
